// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"styles_scrollContainer__xqQ7v","clickableBreadcrumbItem":"styles_clickableBreadcrumbItem__LUEWr"};